import React, { useState } from "react";
import {
  Form,
  Title,
  Input,
  InputGroup,
  Label,
  Timer,
} from "styles/common/FormStyle";
import { CommonWrapper, Background } from "styles/common/Layout";
import { ButtonOutline } from "styles/common/ButtonStyle";
import { sendSMSForFindAccount, verifySMS } from "api/message";
import { findAccount } from "api/user";
import { TextPrimary, TextBlack } from "styles/common/TextStyle";
import { BoxOutline } from "styles/common/BoxStyle";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const [form, setForm] = useState({
    phoneNumber: "",
    code: "",
    logId: "",
  });

  const [userId, setUserId] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const completeForm = Object.values(form).every((value) => value);

  const [isMessageSent, setIsMessageSent] = useState(false);
  const [isMessageVerified, setIsMessageVerified] = useState(false);
  const [timer, setTimer] = useState(0);

  const countDown = () => {
    setTimer(180);
    const interval = setInterval(() => {
      setTimer((timer) => timer - 1);
    }, 1000);
    setTimeout(() => {
      clearInterval(interval);
    }, 180000);
  };

  // show seconds as mm:ss
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  };

  const sendMessage = async () => {
    try {
      const { phoneNumber } = form;
      await sendSMSForFindAccount(phoneNumber);
      setIsMessageSent(true);
      setIsMessageVerified(false);
      countDown();
      alert("인증번호가 전송되었습니다.");
    } catch (err) {
      alert(err);
    }
  };

  const verifyMessage = async () => {
    try {
      const { phoneNumber, code } = form;
      const res = await verifySMS(phoneNumber, code);
      const logId = res?.data?.logId;
      form.logId = logId;
      setForm(form);
      setIsMessageVerified(true);
      alert("인증되었습니다.");
    } catch (err) {
      alert(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { logId, phoneNumber } = form;

      const res = await findAccount({ logId, phoneNumber });
      setUserId(res?.userId);
    } catch (error) {
      alert(error);
    }
  };

  return (
    <Background>
      <CommonWrapper>
        {userId ? (
          <BoxOutline margin="40px 0">
            <TextBlack align="center">
              등록하신 아이디는 <TextPrimary weight="700">{userId}</TextPrimary>{" "}
              입니다.
            </TextBlack>
            <Link to="/login">
              <ButtonOutline height="40px" margin="20px 0 0 0">
                로그인 하러가기
              </ButtonOutline>
            </Link>
          </BoxOutline>
        ) : (
          <Form onSubmit={handleSubmit}>
            <Title>계정 찾기</Title>
            <Label htmlFor="userId">휴대폰 번호</Label>
            <InputGroup>
              <Input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={form[0]?.phoneNumber}
                onChange={handleChange}
                placeholder="휴대폰 번호를 입력해주세요."
                disabled={isMessageSent}
              />
              <ButtonOutline
                type="button"
                onClick={sendMessage}
                width="160px"
                height="40px"
                margin="0 0 0 10px"
                disabled={isMessageVerified}
              >
                {isMessageSent ? "재전송" : "인증번호 받기"}
              </ButtonOutline>
            </InputGroup>
            {isMessageSent && (
              <>
                <Label htmlFor="code">인증번호</Label>
                <InputGroup>
                  <Input
                    type="text"
                    id="code"
                    name="code"
                    value={form[0]?.code}
                    onChange={handleChange}
                    placeholder="인증번호를 입력해주세요."
                    disabled={isMessageVerified}
                  />
                  {isMessageSent && !isMessageVerified && (
                    <Timer>{formatTime(timer)}</Timer>
                  )}
                  <ButtonOutline
                    type="button"
                    onClick={verifyMessage}
                    width="120px"
                    height="40px"
                    margin="0 0 0 10px"
                    disabled={isMessageVerified}
                  >
                    확인
                  </ButtonOutline>
                </InputGroup>
                <ButtonOutline type="submit" disabled={!completeForm}>
                  확인
                </ButtonOutline>
              </>
            )}
          </Form>
        )}
      </CommonWrapper>
    </Background>
  );
};

export default ForgotPassword;
